import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("path", {
  d: "M7.5 5L12.5 10L7.5 15",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1)

import VIconBase from '../VIconBase.vue'

export default /*#__PURE__*/_defineComponent({
  __name: 'RightArrowIcon',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(VIconBase, {
    name: "right-arrow",
    width: "20",
    height: "20",
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, {
    default: _withCtx(() => [
      _hoisted_1
    ]),
    _: 1
  }))
}
}

})